import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import lodash from 'lodash';
import styled from 'styled-components';

import FetchModule from '../../../../Model/Network/FetchModule';
import SubmitBox from '../Model/SubmitBox';
import SubmitCompleteModal from '../Model/SubmitCompleteModal';

import CrownIcon from '../../../../Image/CrownIcon.png';
import DownloadIcon from '../../../../Image/DownloadIcon.png';
import WaitIcon from '../../../../Image/WaitIcon.png';

export default function UserWodDetailPage() {
  const { t, i18n } = useTranslation();

  const changeLanguageToKo = () => i18n.changeLanguage('ko');
  const changeLanguageToEn = () => i18n.changeLanguage('en');

  const params = useParams();

  const navigate = useNavigate();

  const [oragnizerId, setOrganizerId] = useState(0);
  const [eventId, setEventId] = useState(0);
  const [eventTitle, setEventTitle] = useState('');
  // const [eventProfile, setEventProfile] = useState('');
  const [wods, setWods] = useState([]);
  const [clickedWodId, setClickedWodId] = useState(0);

  const [wodSubTitle, setWodSubTitle] = useState('');
  const [wodTitle, setWodTitle] = useState('');
  const [startDate, setStartDate] = useState(moment().add(1, 'days'));
  const [startTime, setStartTime] = useState('10:00');
  const [endDate, setEndDate] = useState(moment().add(1, 'days'));
  const [endTime, setEndTime] = useState('23:59');
  const [sortMethod, setSortMethod] = useState('asc');
  const [pointGap, setPointGap] = useState(1);
  const [scoreRules, setScoreRules] = useState([]);
  const [wodVideo, setWodVideo] = useState('');
  const [wodProgram, setWodProgram] = useState('');
  const [wodNote, setWodNote] = useState('');
  const [wodFlowPlan, setWodFlowPlan] = useState('');
  const [wodRuleBook, setWodRuleBook] = useState('');
  const [wodViewIndex, setWodViewIndex] = useState(1);

  const [scoreSheets, setScoreSheets] = useState([]);
  const [videoURL, setVideoURL] = useState('');
  const [titleWidth, setTitleWidth] = useState('calc(100% - 30px)');
  const [isInProgress, setIsInProgress] = useState(false);
  const [isClickedSubmit, setIsClickedSubmit] = useState(false);
  const [isAlreadySubmit, setIsAlreadySubmit] = useState(false);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const [totalVideoWidth, setTotalVideoWidth] = useState(374);
  const [totalVideoHeight, setTotalVideoHeight] = useState(374);
  const [nowSection, setNowSection] = useState('A');
  const [videoId, setVideoId] = useState('');
  const [title, setTitle] = useState('');
  const [isClickedViewVideo, setIsClickedViewVideo] = useState(false);
  const [isCompleteSubmit, setIsCompleteSubmit] = useState(false);

  const [language, setLanguage] = useState('Korea');

  const TopLevelRef = useRef();
  const SubTitleRef = useRef();

  const newScoreSheet = {
    // tag: 'ForTime',
    // round: 1,
    // isUseTimeCap: false,
    // exerciseMin: 0,
    // exerciseSec: 0,
    // restMin: 0,
    // restSec: 0,
    // customText: '',
    // scoreKeyword: 'Not Scored',
    // scorePriority: 'Heighter',
    // isUseTieBreak: false,

    // tieBreakTag: 'ForTime',
    // tieBreakRound: 1,
    // tieBreakIsUseTimeCap: false,
    // tieBreakExerciseMin: 0,
    // tieBreakExerciseSec: 0,
    // tieBreakRestMin: 0,
    // tieBreakRestSec: 0,
    // tieBreakCustomText: '',
    // tieBreakScoreKeyword: 'Not Scored',
    // tieBreakScorePriority: 'Heighter',

    // viewIndex: 0,

    // 여기부터 //
    isSuccess: false,

    min: 0,
    sec: 0,
    milliSec: 0,
    round: 0,
    reps: 0,
    roundOfCount: [0],
    customValue: 0,

    tieBreakIsSuccess: false,
    tieBreakMin: 0,
    tieBreakSec: 0,
    tieBreakMilliSec: 0,
    tieBreakRound: 0,
    tieBreakReps: 0,
    tieBreakRoundOfCount: [0],
    tieBreakCustomValue: 0,

    // experience: '',
    videoURL: ''
  }

  // 와드 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfEventVer2('wod/detail/' + params.eventId, 'GET');
        // console.log(responseData.data);
        if (responseData.status === 200) {
          setEventTitle(responseData.data.eventTitle);
          // setEventProfile(responseData.data.eventProfile);
          setOrganizerId(responseData.data.organizerId);
          setEventId(responseData.data.eventId);
          setWods(responseData.data.wods);
          // console.log(responseData.data.wods[0].wodId);
          if (responseData.data.wods.length > 0) setClickedWodId(responseData.data.wods[0].wodId);
        }
      }
    )();
  }, [])


  // 기록 제출 데이터 불러오기 //
  useEffect(() => {
    if (clickedWodId === 0) return;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataOfEventVer2('wod_record/' + clickedWodId, 'GET');
        // console.log(responseData.data);
        if (responseData.status === 200) {
          let newScoreSheets = responseData.data.slice();

          if (newScoreSheets.length > 0) {
            setVideoURL(newScoreSheets[0].videoUrl);
            setIsAlreadySubmit(true);
          }

          setScoreSheets(responseData.data);
        }
      }
    )();
  }, [clickedWodId])

  // 선택된 와드에 따라 데이터 변환 //
  useEffect(() => {
    let selectedWod = wods.find(wod => wod.wodId === parseInt(clickedWodId));

    // 값이 없는경우 //
    if (selectedWod === undefined) {
      setWodSubTitle('');
      setWodTitle('');
      setScoreRules([]);
      setScoreSheets([]);
      setStartDate(moment());
      setEndDate(moment());
      setWodVideo('');
      setWodProgram('');
      setWodNote('');
      setWodFlowPlan('');
      setWodRuleBook('');
      setWodViewIndex(1);
    }
    // 값이 있는경우 //
    else {
      setWodSubTitle(selectedWod.wodSubTitle);
      setWodTitle(selectedWod.wodTitle);
      setScoreRules(selectedWod.scoreRules);
      setStartDate(moment(selectedWod.startDate));
      setEndDate(moment(selectedWod.endDate));
      setWodVideo(selectedWod.video);
      setWodProgram(selectedWod.program);
      setWodNote(selectedWod.note);
      setWodFlowPlan(selectedWod.flowPlan);
      setWodRuleBook(selectedWod.ruleBook);
      setWodViewIndex(selectedWod.viewIndex);
    }
  }, [wods, clickedWodId])

  useEffect(() => {
    let subTitleWidth = SubTitleRef.current?.offsetWidth;

    setTitleWidth('calc(100% - ' + (subTitleWidth + 10) + 'px)');
  }, [wodSubTitle])

  // 페이지 이름 변경내역 업로드 //
  useEffect(() => {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify({ pageName: eventTitle, isAvailableGoback: true }));
    }
    catch (e) {
      console.log("Web Message Post Error : " + e);
    }
  }, [eventTitle]);

  // Message Detect Save And Delete //
  useEffect(() => {
    // Android //
    document.addEventListener('message', handleMassage);

    // IOS //
    window.addEventListener('message', handleMassage);

    return () => {
      // Android //
      document.removeEventListener('message', handleMassage);

      // IOS //
      window.removeEventListener('message', handleMassage);
    }
  }, [])

  // // Section 저장 //
  // useEffect(() => {
  //   (
  //     async () => {
  //       if (nowSection === '') {
  //         var prevSection = await window.localStorage.getItem('NowSection') === 'null' ? 'A' : window.localStorage.getItem('NowSection');

  //         setNowSection(prevSection);
  //       }
  //       else await window.localStorage.setItem('NowSection', nowSection);
  //     }
  //   )();

  //   TopLevelRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
  // }, [nowSection])


  // 화면 크기 추출후 총 비디오 박스 크기 계산 //
  useEffect(() => {
    // var finalSize = windowSize.width * 0.3208;
    let totalVideoWidth = windowSize.width * 0.9033;
    let totalVideoHeight = totalVideoWidth * 0.5614;

    setTotalVideoWidth(totalVideoWidth);
    setTotalVideoHeight(totalVideoHeight);
  }, [windowSize])

  // React Native에서 웹으로 보내는 데이터 handler //
  function handleMassage(e) {
    // 언어 정보 받아오기 //
    let language = JSON.parse(e.data).language;

    if (language === 'Korea') changeLanguageToKo();
    else if (language === 'English') changeLanguageToEn();

    if (language !== undefined) setLanguage(language);
  }

  // 이벤트 오픈 결정 //
  function decideEventOpen() {
    return moment().isAfter(startDate);
    // return true;
  }

  // 이벤트 컬럼 이름 결정 //
  function decideEventColumn(data) {
    if (data.wodSubTitle === undefined || data.wodSubTitle === '') return 'Event ' + data.viewIndex;
    else return data.wodSubTitle;
  }

  // 이벤트 영상 URL 정리 //
  function decideWodVideo() {
    // let videoId = wodVideo.replace('https://www.youtube.com/watch?v=', '').replace('https://youtube.com/shorts/', '').replace('https://youtu.be/', '');

    // return 'https://www.youtube.com/embed/' + videoId;

    if (wodVideo.includes('https://www.youtube.com/watch?v=')
      || wodVideo.includes('https://youtube.com/shorts/')
      || wodVideo.includes('https://youtu.be/')) {
      let videoId = wodVideo.replace('https://www.youtube.com/watch?v=', '')
        .replace('https://youtube.com/shorts/', '')
        .replace('https://youtu.be/', '')
        .replace('&list=', '?list=')
        .split('&si=')[0];
      return 'https://www.youtube.com/embed/' + videoId;
    }
    else {
      let videoId = wodVideo.replace('https://www.youtube.com/playlist?list=', '').split('&si=')[0];
      
      return 'https://www.youtube.com/embed/videoseries?list=' + videoId;
    }
  }

  // 기록하기 버튼 텍스트 결정 //
  function decideSaveButtonText() {
    if (isAlreadySubmit && !isClickedSubmit) return t('다시 제출하기');
    else if (isClickedSubmit) return t('제출하기');
    else return t('기록하기');
  }

  // 와드 세션 클릭시 //
  function onClickWod(data) {
    setIsAlreadySubmit(false);
    setIsClickedSubmit(false);
    setClickedWodId(data.wodId);
  }

  // 체점 기준표 다운로드 //
  function downloadRuleBook() {
    try {
      // 파일명 추출
      const encodedFileName = wodRuleBook.split('/').pop();
      const decodedFileName = decodeURIComponent(encodedFileName);

      // 디렉토리 경로 추출
      const baseUrl = wodRuleBook.replace('/' + encodedFileName, '');

      window.ReactNativeWebView.postMessage(JSON.stringify({ downloadURL: baseUrl, fileName: decodedFileName }));
    }
    catch (e) {
      console.log("Web Message Post Error : " + e);
    }
  }

  // 메인 기록 정리 //
  // 제출 기록 타임캡 안에 성공 클릭시 //
  function onChangeIsSuccess(value, index) {
    if (!isClickedSubmit) return;

    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].isSuccess = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 시간(분) 변경시 //
  function onChangeMin(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].min = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 시간(초) 변경시 //
  function onChangeSec(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].sec = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 시간(밀리초) 변경시 //
  function onChangeMilliSec(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].milliSec = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 라운드 변경시 //
  function onChangeRound(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].round = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 렙수 변경시 //
  function onChangeReps(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].reps = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 커스텀 변수 변경시 //
  function onChangeCustomValue(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].customValue = value;
    setScoreSheets(newScoreSheets);
  }
  // 메인 기록 정리 //


  // 타이브레이크 기록 정리 //
  // 제출 기록 타임캡 안에 성공 클릭시 //
  function onChangeTieBreakIsSuccess(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].tieBreakIsSuccess = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 시간(분) 변경시 //
  function onChangeTieBreakMin(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].tieBreakMin = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 시간(초) 변경시 //
  function onChangeTieBreakSec(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].tieBreakSec = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 시간(밀리초) 변경시 //
  function onChangeTieBreakMilliSec(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].tieBreakMilliSec = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 라운드 변경시 //
  function onChangeTieBreakRound(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].tieBreakRound = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 렙수 변경시 //
  function onChangeTieBreakReps(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].tieBreakReps = value;
    setScoreSheets(newScoreSheets);
  }

  // 제출 기록 커스텀 변수 변경시 //
  function onChangeTieBreakCustomValue(value, index) {
    let newScoreSheets = scoreSheets.slice();

    newScoreSheets[index].tieBreakCustomValue = value;
    setScoreSheets(newScoreSheets);
  }
  // 타이브레이크 기록 정리 //



  // 기록하기 클릭시 //
  function onClickSaveButton() {
    if (isClickedSubmit) {
      if (isInProgress) {
        alert('기록 제출이 진행중입니다');
        return;
      }

      setIsInProgress(true);
      // setIsClickedSubmit(false);
      let selectedWod = wods.find(wod => wod.wodId === parseInt(clickedWodId));
      let willSaveScoreSheets = lodash.cloneDeep(scoreSheets);

      for (let i = 0; i < willSaveScoreSheets.length; i++) {
        willSaveScoreSheets[i].eventId = parseInt(params.eventId);
        willSaveScoreSheets[i].wodId = selectedWod.wodId;
        willSaveScoreSheets[i].scoreRuleId = scoreRules[i].scoreRuleId;

        willSaveScoreSheets[i].roundOfCount = '';
        willSaveScoreSheets[i].tieBreakRoundOfCount = '';

        willSaveScoreSheets[i].min = parseInt(willSaveScoreSheets[i].min);
        willSaveScoreSheets[i].sec = parseInt(willSaveScoreSheets[i].sec);
        willSaveScoreSheets[i].milliSec = parseInt(willSaveScoreSheets[i].milliSec);
        willSaveScoreSheets[i].round = parseInt(willSaveScoreSheets[i].round);
        willSaveScoreSheets[i].reps = parseInt(willSaveScoreSheets[i].reps);
        willSaveScoreSheets[i].customValue = parseInt(willSaveScoreSheets[i].customValue);

        willSaveScoreSheets[i].tieBreakMin = parseInt(willSaveScoreSheets[i].tieBreakMin);
        willSaveScoreSheets[i].tieBreakSec = parseInt(willSaveScoreSheets[i].tieBreakSec);
        willSaveScoreSheets[i].tieBreakMilliSec = parseInt(willSaveScoreSheets[i].tieBreakMilliSec);
        willSaveScoreSheets[i].tieBreakRound = parseInt(willSaveScoreSheets[i].tieBreakRound);
        willSaveScoreSheets[i].tieBreakReps = parseInt(willSaveScoreSheets[i].tieBreakReps);
        willSaveScoreSheets[i].tieBreakCustomValue = parseInt(willSaveScoreSheets[i].tieBreakCustomValue);

        willSaveScoreSheets[i].videoUrl = videoURL;
      }

      let requestData = {
        eventId: parseInt(params.eventId),
        wodId: selectedWod.wodId,
        scoreSheets: willSaveScoreSheets
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataOfEventVer2('wod_record/save', 'POST', requestData);
          // console.log(responseData);
          if (responseData.status === 200) {
            setIsCompleteSubmit(true);
            setIsInProgress(false);
          }
          else if (responseData.status === 201) {
            alert('기록 제출 가능 시각이 아닙니다');
            setIsInProgress(false);
          }
          else if (responseData.status === 202) {
            alert('기록 제출 가능 시각이 아닙니다');
            setIsInProgress(false);
          }
          else if (responseData.status === 401) {
            alert('제출 권한이 없습니다');
            setIsInProgress(false);
          }
          else {
            alert('기록 제출에 실패했습니다\n잠시 후 다시시도해주세요');
            setIsInProgress(false);
          }
        }
      )();
    }
    else {
      if (isAlreadySubmit) {
        const confirmResult = window.confirm(t("이전 저장내역이 존재합니다\n계속 진행하시면 이전 데이터는 삭제됩니다"));

        // 아니요 눌렀을 경우 //
        if (!confirmResult) {
          return;
        }
      }

      if (scoreSheets.length === 0) {
        let newScoreSheets = [];

        for (let i = 0; i < scoreRules.length; i++) {
          let finalScoreSheet = lodash.cloneDeep(newScoreSheet);

          if (scoreRules[i].tag === 'EMOM' || scoreRules[i].tag === 'TABATA') {
            let roundCount = [];

            for (let j = 0; j < scoreRules[i].round; j++) {
              roundCount.push(0);
            }

            finalScoreSheet.roundOfCount = roundCount;
          }

          if (scoreRules[i].tieBreakTag === 'EMOM' || scoreRules[i].tieBreakTag === 'TABATA') {
            let roundCount = [];

            for (let j = 0; j < scoreRules[i].round; j++) {
              roundCount.push(0);
            }

            finalScoreSheet.tieBreakRoundOfCount = roundCount;
          }

          newScoreSheets.push(finalScoreSheet);
        }

        setScoreSheets(newScoreSheets);
      }

      setIsClickedSubmit(true);
    }
  }

  // 룰북 다시보기 클릭시 //
  function onClickViewRuleBook() {
    setIsClickedSubmit(false);
    setIsAlreadySubmit(false);
  }

  // 순위표 버튼 클릭시 //
  function onClickGoRanking() {
    // alert('준비중입니다');
    // navigate('/rank/' + params.eventId);
    navigate('/rank/' + oragnizerId + '/' + params.eventId);
  }

  // 모달 임시 
  function onClickGoRanking2() {
    setIsClickedSubmit(false);
    setIsCompleteSubmit(false);
    window.location.reload();
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <TotalWrapper>
        {
          isCompleteSubmit && <SubmitCompleteModal yesFn={onClickGoRanking2} />
        }
        <TopLineWrapper>
          <TitleWrapper>
            <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#4F4F4F'>{eventTitle}</Text>
          </TitleWrapper>
        </TopLineWrapper>
        <SectionButtonLineWrapper>
          <SectionButtonWrapper>
            {
              wods.map((data, index) => (
                <WodSubTitleColumnBox
                  key={'Wod-' + index}
                  isClicked={data.wodId === clickedWodId}
                  onClick={() => onClickWod(data)}>
                  <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='pointer'>{decideEventColumn(data)}</Text>
                </WodSubTitleColumnBox>
              ))
            }
          </SectionButtonWrapper>
          <RankingButton onClick={onClickGoRanking}>
            <CrownImage src={CrownIcon} />
          </RankingButton>
        </SectionButtonLineWrapper>
        {
          decideEventOpen() ?
            <TotalWodWrapper>
              <TotalWodTitleBox>
                <WodSubTitleBox ref={SubTitleRef}>
                  <WodTitleTextWrapper>
                    <Text style={{ width: '100%', height: '100%', whiteSpace: 'nowrap', overflow: 'hidden' }} fontFamily='NotoSansKR-Black' fontSize={14} color='#FFFFFF'>{wodSubTitle}</Text>
                  </WodTitleTextWrapper>
                </WodSubTitleBox>
                <WodTitleBox width={titleWidth}>
                  <WodTitleTextWrapper>
                    <Text style={{ width: '100%', height: '100%', whiteSpace: 'nowrap', overflow: 'hidden' }} fontFamily='NotoSansKR-Black' fontSize={14} color='#4F4F4F'>{wodTitle}</Text>
                  </WodTitleTextWrapper>
                </WodTitleBox>
              </TotalWodTitleBox>
              {
                wodVideo !== '' &&
                <TotalVideoBox width={totalVideoWidth} height={totalVideoHeight}>
                  <iframe
                    width='100%'
                    height='100%'
                    src={decideWodVideo()}
                    style={{ borderRadius: '12px' }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube" />
                </TotalVideoBox>
              }
              <ProgramBoxWrapper>
                <ColumnBox backgroundColor='#969696'>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>Program</Text>
                </ColumnBox>
                <TextBox>
                  <PreText fontFamily='NotoSansKR-Medium' fontSize={14} color='#4F4F4F'>{wodProgram}</PreText>
                </TextBox>
              </ProgramBoxWrapper>
              {
                (isClickedSubmit || isAlreadySubmit) ?
                  <ScoreSubmitBoxWrapper>
                    <SubmitBox
                      isSubmit={isClickedSubmit}
                      wodSubTitle={wodSubTitle}

                      onChangeIsSuccess={onChangeIsSuccess}
                      onChangeMin={onChangeMin}
                      onChangeSec={onChangeSec}
                      onChangeMilliSec={onChangeMilliSec}
                      onChangeRound={onChangeRound}
                      onChangeReps={onChangeReps}
                      onChangeCustomValue={onChangeCustomValue}

                      onChangeTieBreakIsSuccess={onChangeTieBreakIsSuccess}
                      onChangeTieBreakMin={onChangeTieBreakMin}
                      onChangeTieBreakSec={onChangeTieBreakSec}
                      onChangeTieBreakMilliSec={onChangeTieBreakMilliSec}
                      onChangeTieBreakRound={onChangeTieBreakRound}
                      onChangeTieBreakReps={onChangeTieBreakReps}
                      onChangeTieBreakCustomValue={onChangeTieBreakCustomValue}

                      scoreRules={scoreRules}
                      scoreSheets={scoreSheets}

                      video={videoURL}
                      setVideo={setVideoURL}

                      onClickViewRuleBook={onClickViewRuleBook} />
                  </ScoreSubmitBoxWrapper>
                  :
                  <FlowPlanAndRuleBookWrapper>
                    {
                      wodNote !== '' &&
                      <ProgramBoxWrapper>
                        <ColumnBox backgroundColor='#FF8B48'>
                          <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>Note</Text>
                        </ColumnBox>
                        <TextBox>
                          <PreText fontFamily='NotoSansKR-Medium' fontSize={14} color='#4F4F4F'>{wodNote}</PreText>
                        </TextBox>
                      </ProgramBoxWrapper>
                    }
                    {wodFlowPlan !== '' && <FlowPlan src={wodFlowPlan} />}
                    {
                      wodRuleBook !== '' &&
                      <RuleBookBoxWrapper>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#333333'>RULE BOOK</Text>
                        <RuleBookDownloadButton onClick={downloadRuleBook}>
                          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF'>{t('룰북 다운 받기')}</Text>
                          <DownloadImage src={DownloadIcon} />
                        </RuleBookDownloadButton>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#333333'>{t('상세한 내용은 반드시 [스코어카드 / 동작기준]을 “룰북 다운 받기” 아이콘을 클릭해주세요')}</Text>
                      </RuleBookBoxWrapper>
                    }
                  </FlowPlanAndRuleBookWrapper>
              }
            </TotalWodWrapper>
            :
            <TotalWodWrapper>
              <WaitWrapper>
                <WaitImage src={WaitIcon} />
                <Text style={{ marginTop: '8px' }} fontFamily='NotoSansKR-Medium' fontSize={14} color='#BDBDBD'>{eventTitle}</Text>
                <Text style={{ marginTop: '2px' }} fontFamily='NotoSansKR-Medium' fontSize={14} color='#BDBDBD'>{startDate.format('YYYY.MM.DD') + ' OPEN'}</Text>
              </WaitWrapper>
            </TotalWodWrapper>
        }
      </TotalWrapper>
      {
        (moment().isBefore(endDate) && decideEventOpen()) &&
        <SubmitButton onClick={onClickSaveButton}>
          <Text fontFamily='NotoSansKR-Bold' fontSize={18} color='#FFFFFF'>{decideSaveButtonText()}</Text>
        </SubmitButton>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  min-height: 100vh;
  height: 100%;

  background-color: #F9F9F9;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding-bottom: 35px;

  width: 100%;
  height: calc(100% - 35px);
`;

const TopLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 90.33%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 20px;

  width: 100%;
`;

const SectionButtonLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 12px;

  width: 90.33%;
`;

const SectionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(100% - 40px);

  gap: 8px;
`;

const TotalWodWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const WodSubTitleColumnBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;

  min-width: 20px;
  height: 22px;

  border-radius: 8px;
  background-color: ${props => props.isClicked ? `#6DD49E` : `#D9D9D9`};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const TotalWodTitleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 14px;

  width: 90.33%;

  gap: 10px;
`;

const WodSubTitleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;

  min-width: 20px;
  max-width: 70px;
  height: 22px;

  border-radius: 8px;
  background-color: #6DD49E;
`;

const WodTitleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 5px;

  width: ${props => props.width};
  height: 22px;

  border-radius: 8px;
  background-color: #F9F9F9;
`;

const WodTitleTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
  
  width: 100%;
  height: 100%;
`;

const TotalVideoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 10px;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 12px;
`;

const ProgramBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
  
  margin-top: 24px;

  width: 90.33%;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 5px;

  height: 20px;

  border-radius: 5px 5px 0px 0px;
  background-color: ${props => props.backgroundColor};
`;

const TextBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px;

  width: calc(100% - 20px);

  border-radius: 0px 5px 5px 5px;
  background-color: #FFFFFF;
`;

const FlowPlanAndRuleBookWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const FlowPlan = styled.img`
  margin-top: 50px;

  width: 100%;
  height: auto;
`;

const RuleBookBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 10px;

  gap: 4px;

  width: 90.33%;
`;

const ScoreSubmitBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
`;

const CrownImage = styled.img`
  width: 22px;
  height: 19px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  text-overflow: ellipsis;

  :hover {
    cursor: default;
  }
`;

const PreText = styled.pre`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: pre-wrap;
  word-break: break-word;

  :hover {
    cursor: default;
  }
`;

const RankingButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;

  border-radius: 8px;
  background-color: #FFB800;

  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const RuleBookDownloadButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 10px;

  width: calc(100% - 20px);
  height: 35px;

  border-radius: 5px;
  background-color: #FFB800;
`;

const DownloadImage = styled.img`
  width: 21px;
  height: 21px;
`;

const SubmitButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 80px;

  border-radius: 20px 20px 0px 0px;
  background-color: #6DD49E;
`;

const WaitWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 74px;
`;

const WaitImage = styled.img`
  width: 148px;
  height: 62px;

  :hover {
    cursor: default;
  }
`;
